import { render, staticRenderFns } from "./wjTrainEdit.vue?vue&type=template&id=1963fb46&"
import script from "./wjTrainEdit.vue?vue&type=script&lang=js&"
export * from "./wjTrainEdit.vue?vue&type=script&lang=js&"
import style0 from "./wjTrainEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports